import { defineMessage } from 'services/localization';

export const messages = {
    submitterRulesPreviewNotFieldPattern: defineMessage('fieldname_that_does_not_match_values'),
    submitterRulesPreviewFieldPattern: defineMessage('fieldname_that_matches_values'),
    submitterRulesPreviewSubmitsWith: defineMessage('can_submit_with_rules'),
    supplierFieldAnyContactText: defineMessage('any_existing_contact_1'),
    submitterRulesPreviewAlwaysSubmit: defineMessage('without_any_restrictions'),
    supplierFieldAnyContactOrNewText: defineMessage('any_existing_or_new_contact'),
    supplierFieldAnySupplierText: defineMessage('any_contact_marked_as_supplier_1'),
    customerFieldAnyCustomerText: defineMessage('any_contact_marked_as_customer_1'),
    submitterRulesPreviewAndText: defineMessage('left_and_right'),
    submitterRulesPreviewOrText: defineMessage('left_or_right'),
    vendorFieldAnyText: defineMessage('any_existing_vendor_1'),
    vendorFieldAnyOrNewText: defineMessage('any_existing_or_new_vendor'),
    beneficiaryFieldAnyText: defineMessage('any_existing_beneficiary'),
    beneficiaryFieldAnyOrNewText: defineMessage('any_existing_or_new_beneficiary'),
};
